export const paymentIdFor = (payment, provider) => {
  if (!payment) {
    return null
  }

  switch(provider) {
    case 'paypal':
      return payment.id
    case 'stripe':
      return payment.paymentIntent.id
    default:
      return null
  }
}

export const transactionUrlFor = ({ payment, paymentProvider, business }) => {
  if (!payment || !paymentProvider) {
    return null
  }

  switch(paymentProvider) {
    case 'paypal':
      return getPaypalSaleId(payment)
    case 'stripe':
      return stripeTransactionUrlFor({ payment, business })
    default:
      return null
  }
}

const stripeTransactionUrlFor = ({ payment, business }) => {
  if (!payment) {
    return null
  }

  if (!business || !business.stripeConnectAccount) {
    return null
  }

  const stripeAccountId = business.stripeConnectAccount.stripeAccountId
  const ENV = window.location.href.indexOf('www.cogsworth.com') !== -1 ? 'production' : 'sandbox'
  const STRIPE_URL = (ENV === 'production' ? `https://dashboard.stripe.com/${stripeAccountId}/payments` : `https://dashboard.stripe.com/${stripeAccountId}/test/payments`)

  return `${STRIPE_URL}/${payment.paymentIntent.id}`
}

const getPaypalSaleId = (payment) => {
  const ENV = window.location.href.indexOf('www.cogsworth.com') !== -1 ? 'production' : 'sandbox'
  const PAYPAL_URL = (ENV === 'production') ? 'https://www.paypal.com' : 'https://www.sandbox.paypal.com'

  if(!payment || !payment.transactions || payment.transactions.length === 0) {
    return null
  }

  const transaction = payment.transactions[0]
  if(!transaction.related_resources || transaction.related_resources.length === 0) {
    return null
  }

  const saleId = transaction.related_resources[0].sale.id

  return `${PAYPAL_URL}/activity/payment/${saleId}`
}

export const requiresPayment = (service, durationValue) => {
  const duration = (service.durations || []).find(d => d.duration === durationValue)
  if (!duration || !duration.price || duration.price === 0) {
    return false
  }

  if (service.requiresPaypalPayment || service.requiresStripePayment) {
    return true
  }

  return false
}

export const requiresPayOnArrival = (service, durationValue) => {
  const duration = (service.durations || []).find(d => d.duration === durationValue)
  if (!duration || !duration.price || duration.price === 0) {
    return false
  }

  if (service.requiresPaypalPayment || service.requiresStripePayment) {
    return false
  }

  return true
}
